import { createSlice } from "@reduxjs/toolkit";

const genericsSlice = createSlice({
  name: "generic",
  initialState: {
    loading: false,
    error: false,
    nextClasses: [],
    nextClassesWA: [],
    allClasses: [],
    allClassesWA: [],
    ratingCriterias: [],
    classesForRating: [],
    allLingos: [],
    levels: [],
    notif: null,
    allTeachers: [],
    lengthNotif: null,
    paginationNotif: {
      totalPages: 0,
      totalFoung: 0,
    },
    readAllNotif: null,
    teachers: [],
    lingoPlans: null,
    lingoTools: [],
    allPlans: null,
    demoClassesObj: [],
    demoClassMessages: null,
    demoClass: null,
    dropDownMenu: false,
    activeTabStudent: "PERSONAL_INFO",
    typeSchedule: "now",
    buyPlans: [],
    allPreviousClasses: [],
    allNextClasses: [],
    allLastSchedules: [],
  },
  reducers: {
    initLoading(state) {
      state.loading = true;
    },
    endLoading(state) {
      state.loading = false;
    },
    setError(state, { payload }) {
      state.error = payload;
    },
    unsetError(state) {
      state.error = false;
    },
    setNextClasses(state, { payload }) {
      state.nextClasses = payload;
    },
    setNextClassesWA(state, { payload }) {
      state.nextClassesWA = payload;
    },
    setAllClasses(state, { payload }) {
      state.allClasses = payload;
    },
    setAllClassesWA(state, { payload }) {
      state.allClassesWA = payload;
    },
    setRatingCriterias(state, { payload }) {
      state.ratingCriterias = payload;
    },
    setClassesForRating(state, { payload }) {
      state.classesForRating = payload;
    },
    setAllLingos(state, { payload }) {
      state.allLingos = payload;
    },
    setLevels(state, { payload }) {
      state.levels = payload;
    },
    setNotif(state, { payload }) {
      state.notif = payload;
    },
    setAllTeachers(state, { payload }) {
      state.allTeachers = payload;
    },
    setLengthNotif(state, { payload }) {
      state.lengthNotif = payload;
    },
    setPaginationNotif(state, { payload }) {
      state.paginationNotif = payload;
    },
    setReadAllNotif(state, { payload }) {
      state.readAllNotif = payload;
    },
    setTeachers(state, { payload }) {
      state.teachers = payload;
    },
    setLingoPlans(state, { payload }) {
      state.lingoPlans = payload;
    },
    setAllPlans(state, { payload }) {
      state.allPlans = payload;
    },
    setLingoTools(state, { payload }) {
      state.lingoTools = payload;
    },
    setDemoClasses(state, { payload }) {
      state.demoClassesObj = payload;
    },
    setDemoClass(state, { payload }) {
      state.demoClass = payload;
    },
    setDemoClassMessages(state, { payload }) {
      state.demoClassMessages = payload;
    },
    setDropDownMenu(state, { payload }) {
      state.dropDownMenu = payload;
    },
    setActiveTabStudent(state, { payload }) {
      state.activeTabStudent = payload;
    },
    setTypeSchedule(state, { payload }) {
      state.typeSchedule = payload;
    },
    setBuyPlans(state, { payload }) {
      state.buyPlans = payload;
    },
    setAllPreviousClasses(state, { payload }) {
      state.allPreviousClasses = payload;
    },
    setAllNextClasses(state, { payload }) {
      state.allNextClasses = payload;
    },
    setAllLastSchedules(state, { payload }) {
      state.allLastSchedules = payload;
    },
    clearPreviousClasses(state) {
      state.allNextClasses = [];
      state.allPreviousClasses = [];
      state.allLastSchedules = [];
    },
  },
});

export const {
  initLoading,
  endLoading,
  setError,
  unsetError,
  setNextClasses,
  setAllClasses,
  setRatingCriterias,
  setClassesForRating,
  setAllLingos,
  setLevels,
  setNotif,
  setAllTeachers,
  setLengthNotif,
  setPaginationNotif,
  setReadAllNotif,
  setTeachers,
  setLingoPlans,
  setLingoTools,
  setAllPlans,
  setDemoClasses,
  setDemoClassMessages,
  setDemoClass,
  setDropDownMenu,
  setNextClassesWA,
  setAllClassesWA,
  setActiveTabStudent,
  setTypeSchedule,
  setBuyPlans,
  setAllPreviousClasses,
  setAllNextClasses,
  clearPreviousClasses,
  setAllLastSchedules,
} = genericsSlice.actions;

export default genericsSlice.reducer;
